import { Box } from '@mui/material';
import type React from 'react';
import { env } from '@repo/env';
import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import { StructuredContentRenderer } from '../..';
import { LINK_TYPES } from './constants';
import { HorizontalHouseAd } from './HorizontalHouseAd';
import { TemplateType } from './types';

export const WPHouseAd = (doc: StructuredContentDocument) => {
  const environment = env.NEXT_PUBLIC_DEPLOYABLE_ENV;
  if (!doc.props.body) {
    if (environment === 'stage' || environment === 'dev') {
      console.warn(
        `WPHouseAd Structured Content Renderer missing content for doc id: ${doc.props.id}`,
      );
    }
    return null;
  }

  const { headline, body, ctaAuthLink, ctaText, ctaType, ctaUrl, featuredMedia, template } =
    doc.props;

  const ctaProps =
    ctaType === LINK_TYPES.AUTH
      ? {
          ctaNode: ctaAuthLink && <StructuredContentRenderer doc={ctaAuthLink} />,
        }
      : { ctaHref: ctaUrl };

  const houseAdProps = {
    headline,
    body,
    ...ctaProps,
    ctaText,
    featuredMedia,
  };

  let houseAd: React.JSX.Element;

  // Add new templates here if needed
  switch (template) {
    case TemplateType.HORIZONTAL:
    default:
      houseAd = <HorizontalHouseAd {...houseAdProps} />;
  }

  return <Box>{houseAd}</Box>;
};
